import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
const PRODUCT_API = '/contacts/'

export default {
  namespaced: true,
  state: {
    contacts: [],
    contact: null,
    search: [],
    dep: ''
  },
  actions: {
    searchContacts ({ commit }, query) {
      return axios.get(PRODUCT_API + query + '&_limit=20')
        .then(contacts => commit('setSearch', contacts))
        .catch(e => console.log(e))
    },
    fetchContacts ({ commit }, query) {
      return axios.get(PRODUCT_API + query + '&_limit=10000')
        .then(contacts => commit('setContacts', contacts))
        .catch(e => console.log(e))
    },
    fetchContact ({ commit }, id) {
      return axios.get(PRODUCT_API + id)
        .then(contact => commit('setContact', contact))
        .catch(e => console.log(e))
    },
    createContact ({ commit }, dep) {
      return axios.post(PRODUCT_API, dep)
        .then(contact => {
          commit('setContact', contact)
          commit('receiveContact', contact)
        })
        .catch(e => console.log(e))
    },
    updateContact ({ commit }, { id, ...contact }) {
      return axios.put(PRODUCT_API + id, contact)
        .then(contact => {
          commit('setContact', contact)
          commit('receiveContact', contact)
          alert.success('Contact cập nhật thành công!')
        })
        .catch(e => console.log(e))
    },
    async updateContacts ({ dispatch }, contacts) {
      for (let item of contacts) {
        await dispatch('updateContact', item)
      }
    },
    removeContact ({ commit }, id) {
      return axios.delete(PRODUCT_API + id)
        .then(contact => {
          commit('removeContact', contact.id)
        })
        .catch(e => console.log(e))
    },
    async removeContacts ({ dispatch }, contacts) {
      for (let contact of contacts) {
        await dispatch('removeContact', contact.id)
      }
    },
    setCurrentContact ({ commit }, contact) {
      commit('setContact', contact)
    },
    clearContacts ({ commit }) {
      commit('setContacts', [])
    }
  },
  mutations: {
    setContacts (state, deps) {
      state.contacts = deps
    },
    setSearch (state, deps) {
      state.search = deps
    },
    setContact (state, dep) {
      state.contact = dep
    },
    receiveContact (state, dep) {
      const i = state.contacts.findIndex(d => d.id === dep.id)
      if (i > -1) {
        state.contacts.splice(i, 1, dep)
      } else {
        state.contacts.unshift(dep)
      }
    },
    removeContact (state, id) {
      const i = state.contacts.findIndex(d => d.id === id)
      if (i > -1) {
        state.contacts.splice(i, 1)
      }
    }
  },
  getters: {
    contact (state) {
      return !state.contact ? {} : state.contact
    },
    contacts (state) {
      return state.contacts
    },
    search (state) {
      return state.search
    }
  }
}
